module.exports = __webpack_public_path__ + "img/prev.a6a09707.png";